export const environment = {
    production: false,
    authorizationServiceUrl: 'https://us-central1-starkey-engage-integration.cloudfunctions.net',
    cloudCoreApiUrl: 'https://core-integration.telehearportal.com/api/v1',
    //This key has to be exposed to show google maps so there's no point in grabbing it from secret manager
    googleMapsApiKey: 'AIzaSyC7DY3e15xBiyYqQJv1ObECHxw_HtHOza0',
    authDomain: 'engage-fall-management-int.web.app',
    projectId: 'starkey-engage-integration'
  };  
